import { FunctionComponent, SVGProps } from 'react';
import { Namespace, TFuncKey } from 'react-i18next';
import ClipboardQuestionIcon from 'assets/images/assist/icons/clipboard-question.svg?react';
import ClockIcon from 'assets/images/assist/icons/clock.svg?react';
import CoinsIcon from 'assets/images/assist/icons/coins.svg?react';
import CommentsIcon from 'assets/images/assist/icons/comments.svg?react';
import FaceGrinHeartsIcon from 'assets/images/assist/icons/face-grin-hearts.svg?react';
import HeadsetIcon from 'assets/images/assist/icons/headset.svg?react';
import InboxIcon from 'assets/images/assist/icons/inbox.svg?react';
import LanguageIcon from 'assets/images/assist/icons/language.svg?react';
import MessageIcon from 'assets/images/assist/icons/message.svg?react';
import PaperPlaneIcon from 'assets/images/assist/icons/paper-plane.svg?react';
import RankingStarIcon from 'assets/images/assist/icons/ranking-star.svg?react';

export const HOSTFULLY_ASSIST_SCHEDULE_DEMO_URL =
  'https://www.hostfully.com/customer-upgrade/?q_showExperience=experience-1784640048740&main_product=Assist';

// TODO: replace with the real Hostfully Assist help article URL once published.
export const HOSTFULLY_ASSIST_HELP_URL = 'https://help.hostfully.com/';

export const FAQ_VISIBLE_COUNT = 7;

type MarketingCardData = {
  descriptionKey: TFuncKey<Namespace<'en'>>;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  testId: string;
  titleKey: TFuncKey<Namespace<'en'>>;
};

export const FEATURE_CARDS = [
  {
    testId: 'assist-feature-card-1',
    Icon: MessageIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card1.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card1.description',
  },
  {
    testId: 'assist-feature-card-2',
    Icon: InboxIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card2.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card2.description',
  },
  {
    testId: 'assist-feature-card-3',
    Icon: ClipboardQuestionIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card3.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card3.description',
  },
  {
    testId: 'assist-feature-card-4',
    Icon: FaceGrinHeartsIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card4.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card4.description',
  },
  {
    testId: 'assist-feature-card-5',
    Icon: LanguageIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card5.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card5.description',
  },
  {
    testId: 'assist-feature-card-6',
    Icon: CommentsIcon,
    titleKey: 'pageHostfullyAssist.marketing.features.card6.title',
    descriptionKey: 'pageHostfullyAssist.marketing.features.card6.description',
  },
] as const satisfies MarketingCardData[];

export const BENEFIT_CARDS = [
  {
    testId: 'assist-benefit-card-1',
    Icon: PaperPlaneIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card1.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card1.description',
  },
  {
    testId: 'assist-benefit-card-2',
    Icon: ClockIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card2.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card2.description',
  },
  {
    testId: 'assist-benefit-card-3',
    Icon: HeadsetIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card3.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card3.description',
  },
  {
    testId: 'assist-benefit-card-4',
    Icon: CoinsIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card4.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card4.description',
  },
  {
    testId: 'assist-benefit-card-5',
    Icon: RankingStarIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card5.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card5.description',
  },
  {
    testId: 'assist-benefit-card-6',
    Icon: InboxIcon,
    titleKey: 'pageHostfullyAssist.marketing.benefits.card6.title',
    descriptionKey: 'pageHostfullyAssist.marketing.benefits.card6.description',
  },
] as const satisfies MarketingCardData[];

export type MarketingCardContent =
  | (typeof FEATURE_CARDS)[number]
  | (typeof BENEFIT_CARDS)[number];

type FaqContent = {
  answerKey: TFuncKey<Namespace<'en'>>;
  questionKey: TFuncKey<Namespace<'en'>>;
  testId: string;
};

export const FAQ_ITEMS = [
  {
    testId: 'assist-faq-item-1',
    questionKey: 'pageHostfullyAssist.marketing.faq.item1.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item1.answer',
  },
  {
    testId: 'assist-faq-item-2',
    questionKey: 'pageHostfullyAssist.marketing.faq.item2.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item2.answer',
  },
  {
    testId: 'assist-faq-item-3',
    questionKey: 'pageHostfullyAssist.marketing.faq.item3.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item3.answer',
  },
  {
    testId: 'assist-faq-item-4',
    questionKey: 'pageHostfullyAssist.marketing.faq.item4.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item4.answer',
  },
  {
    testId: 'assist-faq-item-5',
    questionKey: 'pageHostfullyAssist.marketing.faq.item5.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item5.answer',
  },
  {
    testId: 'assist-faq-item-6',
    questionKey: 'pageHostfullyAssist.marketing.faq.item6.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item6.answer',
  },
  {
    testId: 'assist-faq-item-7',
    questionKey: 'pageHostfullyAssist.marketing.faq.item7.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item7.answer',
  },
  {
    testId: 'assist-faq-item-8',
    questionKey: 'pageHostfullyAssist.marketing.faq.item8.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item8.answer',
  },
  {
    testId: 'assist-faq-item-9',
    questionKey: 'pageHostfullyAssist.marketing.faq.item9.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item9.answer',
  },
  {
    testId: 'assist-faq-item-10',
    questionKey: 'pageHostfullyAssist.marketing.faq.item10.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item10.answer',
  },
  {
    testId: 'assist-faq-item-11',
    questionKey: 'pageHostfullyAssist.marketing.faq.item11.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item11.answer',
  },
  {
    testId: 'assist-faq-item-12',
    questionKey: 'pageHostfullyAssist.marketing.faq.item12.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item12.answer',
  },
  {
    testId: 'assist-faq-item-13',
    questionKey: 'pageHostfullyAssist.marketing.faq.item13.question',
    answerKey: 'pageHostfullyAssist.marketing.faq.item13.answer',
  },
] as const satisfies FaqContent[];

export type FaqItemContent = (typeof FAQ_ITEMS)[number];
